import { render, staticRenderFns } from "./DashboardIncidentManager.vue?vue&type=template&id=68fa0f97&scoped=true&"
import script from "./DashboardIncidentManager.vue?vue&type=script&lang=js&"
export * from "./DashboardIncidentManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fa0f97",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
